'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { GrantIdeasBlock } from '@/payload-types'
import { Callout } from '@/components/Callout'
import { IdeaCard } from '@/components/IdeaCard'

export function GrantIdeasClient({ heading, description, ideas }: GrantIdeasBlock) {
  return (
    <Section bgClassName="bg-olive-2">
      <Callout
        variant="light"
        heading={heading}
        content={description}
        headingClassName="text-highlighter"
        className="max-w-[800px] text-balance"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[50px]">
        {ideas?.map((idea) => <IdeaCard key={idea.id} {...idea} variant="light" />)}
      </div>
    </Section>
  )
}
